import React from 'react';
import UncomposedEdit from './UnComposedEdit';
import {
  EditPageContainer,
  withServerErrors,
  withResolver,
  withDebug,
} from 'components/common';
import { compose, withState} from 'recompose';

const enhance = compose(
  withServerErrors(),
  EditPageContainer({
    url: 'users',
    convertServerErrors: ['password', 'email'],
    defaultItem: ({role}) => ({
      is_active: false,
      role: role
    }),
  }),
  withState('serverErrors', 'setServerErrors', {}),
  withState('roles', 'setRoles', []),
  withResolver(
    {
      roles: () => client => client.get('/users/permitted_roles'),
    },
    {
      onResolved: ({ setRoles }) => ({ roles }) => {
        setRoles(roles);
      },
    }
  ),
  withState('resellers', 'setResellers', []),
  withResolver(
    {
      resellers: () => client => client.get('/white-label-partners'),
    },
    {
      onResolved: ({ setResellers }) => ({ resellers }) => {
        setResellers(resellers);
      },
    }
  )
);

export default enhance(UncomposedEdit);



// WEBPACK FOOTER //
// ./src/pages/Users/Edit.jsx